var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-5xl xl:text-6xl xxl:text-7xl text-primary font-bold",domProps:{"textContent":_vm._s(_vm.displayNumber + '+')}})}
var staticRenderFns = []

export { render, staticRenderFns }